/**
 * Verification Emails Controller
 * Defines the interface for our Verification Emails Object
 */

// Import API singleton and appropriate resource interface
import api, { resolveWithStatus } from "@/services/api/api";

// Define all of your actions
const create = async (
  body: { user_id: string; client_id: string },
  accessToken: string
): Promise<any> => {
  try {
    const response = await api.post("/verification-emails", body, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });

    return response;
  } catch (error) {
    throw error;
  }
};

// Then export all the actions
export default {
  create
};
